import ShopAdvancedSelector from './shop-advanced-selector.vue'

ShopAdvancedSelector.install = function (Vue) {
	Vue.component(ShopAdvancedSelector.name, ShopAdvancedSelector);
}

export default ShopAdvancedSelector;